import { DEBUG_QUESTIONNAIRE_RENDER_LOGGING } from '@/configuration/client';
import trackEvents from '@/helpers/trackEvents';

const noop = (..._args: unknown[]): void => undefined;

export const questionnaireRenderLogger: Pick<Console, 'log' | 'warn'> = DEBUG_QUESTIONNAIRE_RENDER_LOGGING
  ? console
  : {
      log: noop,
      warn: noop,
    };

export const trackQuestionnaireRenderLog = (...args: string[]): void => {
  if (!DEBUG_QUESTIONNAIRE_RENDER_LOGGING) {
    return;
  }

  trackEvents.track(...args);
};
